import { createRouteRef } from '@backstage/frontend-plugin-api';

/** The org chart page, `/org`; Group pages link into it as `/org#<name>`. */
export const orgChartRouteRef = createRouteRef();
